<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header"></div>
            <div class="card-body">
              <div v-if="loadingIntegration" class="integration-loading">
                <small class="text-muted">
                  <i class="fas fa-spinner fa-spin mr-1"></i>
                  Checking FastMedic integration...
                </small>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <label>Nome</label>
                  <input
                      v-model="professionals.name"
                      class="form-control"
                      type="text"
                  />
                </div>
                <div class="col-md-3">
                  <label for="cpf">CPF:</label>
                  <div class="input-group">
                    <input
                        v-model="professionals.cpf"
                        v-mask="'999.999.999-99'"
                        class="form-control"
                        type="text"
                        placeholder="000.000.000-00"
                        @input="onCpfChange"
                        @blur="validateCpf"
                        @focus="clearCpfValidation"
                    />
                    <div v-if="showFastMedicButton" class="input-group-append">
                      <button
                          @click="searchFastMedic"
                          :disabled="!canSearchFastMedic"
                          class="btn btn-info"
                          type="button"
                          :title="searchButtonTooltip"
                      >
                        <i v-if="loadingFastMedic" class="fas fa-spinner fa-spin"></i>
                        <i v-else class="fas fa-search"></i>
                      </button>
                    </div>
                  </div>

                  <div class="feedback-messages">
                    <small v-if="errorFastMedic" class="text-danger d-block">
                      <i class="fas fa-exclamation-circle mr-1"></i>
                      {{ errorFastMedic }}
                    </small>

                    <small v-else-if="fastMedicDataLoaded && !errorFastMedic" class="text-success d-block">
                      <i class="fas fa-check mr-1"></i>
                      Usuário encontrado e formulário preenchido!
                    </small>

                    <small v-else-if="showCpfValidationError" class="text-warning d-block">
                      <i class="fas fa-exclamation-triangle mr-1"></i>
                      Formato de CPF inválido
                    </small>
                  </div>
                </div>
                <div class="col-md-3">
                  <label for="rg">SUS:</label>
                  <input
                      v-model="professionals.rg"
                      class="form-control"
                      type="text"
                  />
                </div>
                <div class="col-md-4">
                  <label for="advice_id">Conselho:</label>
                  <v-select
                      v-model="professionals.advice_id"
                      class="vselect"
                      :options="advice"
                      :reduce="(advice) => advice.id"
                      :label="'title'"
                      :loading="loadingAdvice"
                  />
                </div>
                <div class="col-md-3">
                  <label for="number_advice">Número do Conselho:</label>
                  <input
                      v-model="professionals.number_advice"
                      class="form-control"
                      type="text"
                  />
                </div>
                <div class="col-md-5">
                  <label for="specialty_id">Especialidade:</label>
                  <v-select
                      v-model="professionals.specialty_id"
                      class="vselect"
                      :options="specialties"
                      :reduce="(specialties) => specialties.id"
                      :label="'title'"
                      :loading="loadingSpecialties"
                  />
                </div>

                <div class="col-md-4">
                  <label>CEP</label>
                  <input
                      type="text"
                      v-model="professionals.cep"
                      class="form-control"
                      v-on:keyup="searchAddress"
                      v-mask="'99999-999'"
                  />
                </div>
                <div class="col-md-8">
                  <label>Logradouro</label>
                  <input
                      type="text"
                      v-model="professionals.logradouro"
                      class="form-control"
                  />
                </div>
                <div class="col-md-4">
                  <label>Complemento</label>
                  <input
                      type="text"
                      v-model="professionals.complement"
                      class="form-control"
                  />
                </div>
                <div class="col-md-4">
                  <label>Número</label>
                  <input
                      type="text"
                      v-model="professionals.number"
                      class="form-control"
                      id="inputNumero"
                  />
                </div>
                <div class="col-md-4">
                  <label>Bairro</label>
                  <input
                      type="text"
                      v-model="professionals.neighborhood"
                      class="form-control"
                  />
                </div>
                <div class="col-md-3">
                  <label>Cidade</label>
                  <input
                      type="text"
                      v-model="professionals.city"
                      class="form-control"
                  />
                </div>
                <div class="col-md-2">
                  <label>Estado</label>
                  <input
                      type="text"
                      v-model="professionals.state"
                      class="form-control"
                  />
                </div>

                <div class="col-md-10 mt-3">
                  <label>Empresa</label>
                  <v-select
                      v-model="company_selected"
                      class="vselect"
                      :options="companies"
                      :label="'fantasy_name'"
                      :loading="loadingCompanies"
                  />
                </div>

                <div class="col-md-2 mt-5">
                  <button
                      class="btn btn-add"
                      style="margin-top: 12px"
                      @click="addCompany"
                  >
                    Adicionar
                  </button>
                </div>

                <div
                    class="col-md-12 mt-2"
                    v-if="professionals.companies.length > 0"
                >
                  <h3>Empresas Vinculadas</h3>
                </div>
                <div
                    class="col-md-12 mt-1"
                    v-if="professionals.companies.length > 0"
                >
                  <table class="table table-hover">
                    <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Razão Social</th>
                      <th scope="col">Nome Fantasia</th>
                      <th scope="col">CNPJ</th>
                      <th scope="col">Ações</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                        v-for="(company, index) in professionals.companies"
                        :key="company.id"
                    >
                      <th scope="row">{{ index + 1 }}</th>
                      <td>{{ company.name }}</td>
                      <td>{{ company.fantasy_name }}</td>
                      <td>{{ company.cnpj }}</td>
                      <td>
                        <button
                            class="btn btn-crud delete"
                            @click="removeItem(index)"
                        >
                          <i class="fas fa-trash-alt"></i>
                        </button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div class="col-md-12 mt-4">
                  <h3>Capacitação Manchester</h3>
                </div>

                <div class="col-md-4">
                  <label for="manchesterTraining">Profissional capacitado?</label>
                  <div class="manchester-toggle">
                    <label class="switch">
                      <input
                          id="manchesterTraining"
                          v-model="professionals.manchester_training"
                          type="checkbox"
                          @change="onTrainingToggled"
                      />
                      <span class="switch-track">
                        <span class="switch-thumb"></span>
                      </span>
                    </label>
                    <span
                        class="switch-state"
                        :class="{ 'switch-state-on': manchesterEnabled }"
                    >
                      {{ manchesterEnabled ? 'SIM' : 'NÃO' }}
                    </span>
                  </div>
                </div>

                <transition name="manchester-reveal">
                  <div v-if="manchesterEnabled" class="col-md-8">
                    <div class="row">
                      <div class="col-md-6">
                        <label for="manchesterCertificate">Certificado (PDF)</label>
                        <input
                            id="manchesterCertificate"
                            type="file"
                            class="form-control-file"
                            accept="application/pdf"
                            @change="onCertificateSelected"
                        />
                        <div class="feedback-messages">
                          <small v-if="certificateError" class="text-danger d-block">
                            <i class="fas fa-exclamation-circle mr-1"></i>
                            {{ certificateError }}
                          </small>
                          <small v-else-if="certificateName" class="text-success d-block">
                            <i class="fas fa-check mr-1"></i>
                            {{ certificateName }}
                          </small>
                          <a
                              v-else-if="hasSavedCertificate"
                              href="#"
                              class="d-block"
                              @click.prevent="openCertificate"
                          >
                            Ver certificado
                          </a>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <label for="manchesterKey">Chave de autenticidade</label>
                        <div class="input-group">
                          <input
                              id="manchesterKey"
                              v-model="professionals.manchester_auth_key"
                              type="text"
                              class="form-control"
                              @input="clearManchesterResult"
                          />
                          <div class="input-group-append">
                            <button
                                class="btn btn-info"
                                type="button"
                                :disabled="!canValidateManchester"
                                @click="validateManchesterKey"
                            >
                              <i v-if="loadingManchester" class="fas fa-spinner fa-spin"></i>
                              <span v-else>Validar</span>
                            </button>
                          </div>
                        </div>
                        <div class="feedback-messages">
                          <small v-if="manchesterError" class="text-danger d-block">
                            <i class="fas fa-exclamation-circle mr-1"></i>
                            {{ manchesterError }}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </transition>

                <transition name="manchester-reveal">
                  <div v-if="manchesterResult" class="col-md-12 mt-2">
                    <div class="manchester-result">
                      <p class="manchester-intro">
                        A REDEC, Rede de Educação, atesta a validade do certificado para:
                      </p>
                      <dl class="row mb-0">
                        <dt class="col-sm-3">Participante</dt>
                        <dd class="col-sm-9">{{ manchesterResult.data.participante }}</dd>
                        <dt class="col-sm-3">Curso</dt>
                        <dd class="col-sm-9">{{ manchesterResult.data.curso }}</dd>
                        <dt class="col-sm-3">Data</dt>
                        <dd class="col-sm-9">{{ manchesterResult.data.data }}</dd>
                        <dt class="col-sm-3">Validade</dt>
                        <dd class="col-sm-9">{{ manchesterResult.data.validade }}</dd>
                        <dt class="col-sm-3">Data de consulta</dt>
                        <dd class="col-sm-9">{{ manchesterResult.consulted_at }}</dd>
                        <dt class="col-sm-3">URL desta confirmação</dt>
                        <dd class="col-sm-9">
                          <a :href="manchesterResult.url" target="_blank" rel="noopener">
                            {{ manchesterResult.url }}
                          </a>
                        </dd>
                      </dl>
                    </div>
                  </div>
                </transition>

                <div class="col-md-12 text-right">
                  <hr/>
                  <router-link to="/professionals" class="btn btn-back mr-1">
                    <i class="fa fa-arrow-left"/>
                    Voltar
                  </router-link>
                  <a class="btn btn-add" @click="save">
                    Salvar
                    <i class="fa fa-save"/>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "ProfessionalForm",
  components: {
    BaseCrud,
    vSelect,
  },
  data() {
    return {
      company_selected: {},
      specialties: [],
      companies: [],
      advice: [],
      loadingIntegration: false,
      loadingSpecialties: false,
      loadingAdvice: false,
      loadingCompanies: false,
      loadingFastMedic: false,
      errorFastMedic: null,
      fastMedicData: null,
      fastMedicDataLoaded: false,
      hasIntegrationActive: false,
      userCompanyId: null,
      cpfValidationTimer: null,
      cpfValidationError: null,
      certificateError: null,
      certificateName: null,
      loadingManchester: false,
      manchesterError: null,
      manchesterResult: null,
      professionals: {
        name: "",
        cpf: "",
        rg: "",
        advice_id: "",
        specialty_id: "",
        state: "",
        logradouro: "",
        number: "",
        complement: "",
        neighborhood: "",
        city: "",
        cep: "",
        cbo_id: "",
        companies: [],
        number_advice: "",
        manchester_training: false,
        manchester_certificate: "",
        manchester_auth_key: "",
      },
    };
  },
  computed: {
    cpfValid() {
      if (!this.professionals.cpf) return false;
      const cleanCpf = this.professionals.cpf.replace(/[^\d]/g, '');
      return cleanCpf.length === 11 && this.isValidCpf(cleanCpf);
    },

    showFastMedicButton() {
      return this.hasIntegrationActive || this.loadingIntegration;
    },

    canSearchFastMedic() {
      return !this.loadingIntegration &&
          !this.loadingFastMedic &&
          this.cpfValid &&
          this.hasIntegrationActive;
    },

    searchButtonTooltip() {
      if (this.loadingIntegration) return 'Checking integration...';
      if (!this.cpfValid) return 'Enter a valid CPF';
      if (!this.hasIntegrationActive) return 'FastMedic integration not available';
      if (this.loadingFastMedic) return 'Searching...';
      return 'Search CPF in FastMedic';
    },

    showCpfValidationError() {
      return this.cpfValidationError && !this.errorFastMedic;
    },

    manchesterEnabled() {
      return this.professionals.manchester_training === true;
    },

    hasSavedCertificate() {
      const certificate = this.professionals.manchester_certificate;
      return Boolean(
          this.professionals.id &&
          certificate &&
          String(certificate).indexOf('data:') !== 0
      );
    },

    canValidateManchester() {
      const key = this.professionals.manchester_auth_key || '';
      return !this.loadingManchester && key.trim().length > 0;
    },
  },
  mounted() {
    this.initializeForm();
  },
  methods: {
    initializeForm() {
      this.checkUserIntegration();
      this.loadFormData();

      const id = this.$route.params.id;
      if (id) {
        this.getProfessional(id);
      }
    },

    async checkUserIntegration() {
      this.loadingIntegration = true;

      try {
        await this.getCurrentUserWithCompanyId();

        if (this.userCompanyId) {
          await this.checkCompanyIntegration();
        }
      } finally {
        this.loadingIntegration = false;
      }
    },

    loadFormData() {
      this.getSpecialties();
      this.getAdvices();
      this.getCompanies();
    },

    async getCurrentUserWithCompanyId() {
      try {
        const token = this.$store.state.token || localStorage.getItem('token');
        if (!token) return;

        const response = await axios.post(this.$store.state.api + 'me', {token});
        this.userCompanyId = response.data.company_id || response.data.local?.company_id || null;
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    },

    async checkCompanyIntegration() {
      if (!this.userCompanyId) {
        this.hasIntegrationActive = false;
        return;
      }

      try {
        const response = await axios.get(`${this.$store.state.api}companies/${this.userCompanyId}`);
        const company = this.getCompanyFromResponse(response.data);
        this.hasIntegrationActive = company ? Boolean(company.fastmedic_integration) : false;
      } catch (error) {
        this.hasIntegrationActive = false;
      }
    },

    getCompanyFromResponse(responseData) {
      if (responseData?.data?.data?.[0]) return responseData.data.data[0];
      if (responseData?.data?.[0]) return responseData.data[0];
      if (responseData?.[0]) return responseData[0];
      if (responseData?.id) return responseData;
      return null;
    },

    onCpfChange() {
      if (this.errorFastMedic) {
        this.errorFastMedic = null;
      }

      this.cpfValidationError = null;

      if (this.cpfValidationTimer) {
        clearTimeout(this.cpfValidationTimer);
      }
    },

    validateCpf() {
      const cleanCpf = this.professionals.cpf ? this.professionals.cpf.replace(/[^\d]/g, '') : '';

      if (cleanCpf.length === 11) {
        if (!this.cpfValid) {
          this.cpfValidationError = 'Formato de CPF inválido';

          setTimeout(() => {
            this.cpfValidationError = null;
          }, 5000);
        } else {
          this.cpfValidationError = null;
        }
      } else if (cleanCpf.length > 0) {
        this.cpfValidationError = null;
      }
    },

    clearCpfValidation() {
      this.cpfValidationError = null;

      if (this.cpfValidationTimer) {
        clearTimeout(this.cpfValidationTimer);
      }
    },

    onTrainingToggled() {
      if (!this.professionals.manchester_training) {
        this.clearManchester();
      }
    },

    clearManchester() {
      this.professionals.manchester_auth_key = "";
      this.professionals.manchester_certificate = "";
      this.certificateError = null;
      this.certificateName = null;
      this.clearManchesterResult();
    },

    onCertificateSelected(event) {
      const file = event.target.files[0];

      this.certificateError = null;
      this.certificateName = null;

      if (!file) {
        this.professionals.manchester_certificate = "";
        return;
      }

      if (file.type !== 'application/pdf') {
        this.certificateError = 'O certificado precisa ser um arquivo PDF';
        event.target.value = '';
        return;
      }

      if (file.size > 5242880) {
        this.certificateError = 'O certificado não pode passar de 5 MB';
        event.target.value = '';
        return;
      }

      const reader = new FileReader();

      reader.onload = (e) => {
        this.professionals.manchester_certificate = e.target.result;
        this.certificateName = file.name;
      };

      reader.readAsDataURL(file);
    },

    clearManchesterResult() {
      this.manchesterResult = null;
      this.manchesterError = null;
    },

    async validateManchesterKey() {
      if (!this.canValidateManchester) return;

      this.loadingManchester = true;
      this.manchesterError = null;
      this.manchesterResult = null;

      try {
        const response = await axios.post(
            this.$store.state.api + 'professionals/validate-manchester-key',
            {key: this.professionals.manchester_auth_key}
        );

        if (!response.data.success) {
          this.manchesterError = response.data.message || 'Certificado não encontrado';
          this.$message(null, this.manchesterError, 'error');
          return;
        }

        this.manchesterResult = response.data;
        this.$message('Success', 'Certificado validado com sucesso!', 'success');
      } catch (error) {
        this.manchesterError = 'Não foi possível consultar a plataforma do GBCR';
        this.$message(null, this.manchesterError, 'error');
      } finally {
        this.loadingManchester = false;
      }
    },

    async openCertificate() {
      try {
        const api = this.$store.state.api +
            'professionals/' + this.professionals.id + '/manchester-certificate';

        const response = await axios.get(api, {responseType: 'blob'});

        const arquivo = new Blob([response.data], {type: 'application/pdf'});
        const url = URL.createObjectURL(arquivo);

        window.open(url, '_blank');

        setTimeout(() => URL.revokeObjectURL(url), 60000);
      } catch (error) {
        this.$message(null, 'Certificado não encontrado', 'error');
      }
    },

    async searchFastMedic() {
      if (!this.canSearchFastMedic) return;

      this.loadingFastMedic = true;
      this.errorFastMedic = null;
      this.fastMedicData = null;
      this.fastMedicDataLoaded = false;
      this.cpfValidationError = null;

      try {
        const response = await axios.post(
            this.$store.state.api + 'fastmedic-integration',
            {cpf: this.professionals.cpf}
        );

        if (!response.data.success) {
          this.clearFastMedicFields();
          this.errorFastMedic = response.data.message || 'Nenhum dado encontrado para este CPF';
          this.$message(null, this.errorFastMedic, 'error');

          setTimeout(() => {
            this.errorFastMedic = null;
          }, 6000);
          return;
        }

        if (!response.data.data || !Array.isArray(response.data.data) || response.data.data.length === 0) {
          this.clearFastMedicFields();
          this.errorFastMedic = 'Nenhum dado encontrado para este CPF';
          this.$message(null, this.errorFastMedic, 'error');

          setTimeout(() => {
            this.errorFastMedic = null;
          }, 6000);
          return;
        }

        this.fastMedicData = response.data.data;
        this.fillFormWithFastMedicData();
        this.fastMedicDataLoaded = true;
        this.$message('Success', 'Usuário encontrado e formulário preenchido com sucesso!', 'success');

        setTimeout(() => {
          this.fastMedicDataLoaded = false;
        }, 3000);

      } catch (error) {
        const errorMsg = error.response?.data?.message || 'Error connecting to FastMedic';
        this.errorFastMedic = errorMsg;
        this.clearFastMedicFields();
        this.$message(null, errorMsg, 'error');

        setTimeout(() => {
          this.errorFastMedic = null;
        }, 6000);
      } finally {
        this.loadingFastMedic = false;
      }
    },

    clearFastMedicFields() {
      var fields = ['rg', 'name', 'number_advice', 'cbo_id', 'cep', 'logradouro', 'complement', 'number', 'neighborhood', 'city', 'state'];
      for (var i = 0; i < fields.length; i++) {
        this.professionals[fields[i]] = '';
      }
      this.fastMedicData = null;
      this.fastMedicDataLoaded = false;
    },

    isValidCpf(cpf) {
      if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

      let sum = 0;
      for (let i = 0; i < 9; i++) {
        sum += parseInt(cpf.charAt(i)) * (10 - i);
      }
      let digit = 11 - (sum % 11);
      if (digit === 10 || digit === 11) digit = 0;
      if (digit !== parseInt(cpf.charAt(9))) return false;

      sum = 0;
      for (let i = 0; i < 10; i++) {
        sum += parseInt(cpf.charAt(i)) * (11 - i);
      }
      digit = 11 - (sum % 11);
      if (digit === 10 || digit === 11) digit = 0;
      return digit === parseInt(cpf.charAt(10));
    },

    fillFormWithFastMedicData() {
      if (!this.fastMedicData || !Array.isArray(this.fastMedicData) || this.fastMedicData.length === 0) return;
      const data = this.fastMedicData[0];

      const fieldMap = {
        rg: ['numCNSProfissional'],
        cpf: ['numCPFProfissional'],
        name: ['nomeProfissionalSolicitante'],
        number_advice: ['numConsRegistroProfissional'],
        cbo_id: ['numCboProfissional'],
        cep: ['numCepProfissional'],
        logradouro: ['dscLogradouroProfissional'],
        complement: ['dscComplementoProfissional'],
        number: ['numEnderecoProfissional'],
        neighborhood: ['dscBairroProfissional'],
        city: ['dscCidadeProfissional'],
        state: ['dscEstadoProfissional']
      };

      Object.keys(fieldMap).forEach(dest => {
        const keys = fieldMap[dest];
        let value = null;
        for (let i = 0; i < keys.length; i++) {
          const k = keys[i];
          if (data.hasOwnProperty(k) && data[k] != null && data[k] !== '') {
            value = data[k];
            break;
          }
        }
        this.professionals[dest] = value != null ? value : '';
      });

      this.fillAddressFields(data);

      this.selectCouncilByCode(data.sgOrgaoProfissional);

      this.fastMedicData = null;
    },

    fillAddressFields(data) {
      const addressMappings = [
        ['cep', 'numCepProfissional'],
        ['logradouro', 'dscLogradouroProfissional'],
        ['number', 'numEnderecoProfissional'],
        ['complement', 'dscComplementoProfissional'],
        ['neighborhood', 'dscBairroProfissional'],
        ['city', 'dscCidadeProfissional'],
        ['state', 'dscEstadoProfissional']
      ];

      addressMappings.forEach(([localField, dataField]) => {
        if (!this.professionals[localField] && data[dataField]) {
          this.professionals[localField] = data[dataField];
        }
      });
    },

    selectCouncilByCode(code) {
      if (!this.advice.length) {
        this.professionals.advice_id = '';
        return;
      }

      if (!code) {
        this.professionals.advice_id = '';
        return;
      }

    const council = this.advice.find(function(adviceItem) {
      return adviceItem.codigo === code ||
         adviceItem.code === code ||
         String(adviceItem.codigo) === String(code) ||
         String(adviceItem.code) === String(code);
    });

      this.professionals.advice_id = council ? council.id : '';
    },

    removeItem(index) {
      this.professionals.companies.splice(index, 1);
    },

    addCompany() {
      if (!this.company_selected) return;
      this.professionals.companies.push(this.company_selected);
    },

    async save() {
      try {
        let api = this.$store.state.api + "professionals";
        const formData = {...this.professionals};

        if (this.professionals.id) {
          formData._method = "PUT";
          api += "/" + this.professionals.id;
        }

        await axios.post(api, formData);
        this.$message("Success", "Information saved successfully", "success");
        this.$router.push("/professionals");
      } catch (error) {
        this.$message(null, error.response.data, "error");
      }
    },

    async getSpecialties() {
      this.loadingSpecialties = true;
      try {
        const api = this.$store.state.api + "specialties?paginated=false";
        const response = await axios.get(api);
        this.specialties = response.data.data || [];
      } catch (error) {
        this.$message(null, 'Error loading specialties', "error");
      } finally {
        this.loadingSpecialties = false;
      }
    },

    async getAdvices() {
      this.loadingAdvice = true;
      try {
        const api = this.$store.state.api + "advice?paginated=false";
        const response = await axios.get(api);
        this.advice = response.data.data || [];
      } catch (error) {
        this.$message(null, 'Error loading advices', "error");
      } finally {
        this.loadingAdvice = false;
      }
    },

    async getCompanies() {
      this.loadingCompanies = true;
      try {
        const api = this.$store.state.api + "companies?paginated=false";
        const response = await axios.get(api);
        this.companies = response.data.data || [];
      } catch (error) {
        this.$message(null, 'Error loading companies', "error");
      } finally {
        this.loadingCompanies = false;
      }
    },

    async getProfessional(id) {
      try {
        const api = this.$store.state.api + "professionals/" + id + "?with[]=companies";
        const response = await axios.get(api);
        const professional = response.data.data[0];

        professional.manchester_training = professional.manchester_training === true ||
            professional.manchester_training === 1 ||
            professional.manchester_training === '1' ||
            professional.manchester_training === 't';
        professional.manchester_certificate = professional.manchester_certificate || "";
        professional.manchester_auth_key = professional.manchester_auth_key || "";

        this.professionals = professional;
      } catch (error) {
        this.$message(null, 'Error loading professional', "error");
      }
    },

    searchAddress() {
      if (!this.isValidCep(this.professionals.cep)) return;

      this.addressNotFound = false;

      $.getJSON(
          "https://viacep.com.br/ws/" + this.professionals.cep + "/json/",
          (address) => {
            if (address.erro) {
              this.endereco = {};
              $("#inputNumero").focus();
              this.addressNotFound = true;
              return;
            }

            this.populateAddressFields(address);
            $("#inputNumero").focus();
          }
      );
    },

    isValidCep(cep) {
      return /^[0-9]{5}-[0-9]{3}$/.test(cep);
    },

    populateAddressFields(address) {
      this.endereco = address;
      this.professionals.logradouro = address.logradouro;
      this.professionals.complement = address.complemento;
      this.professionals.neighborhood = address.bairro;
      this.professionals.city = address.localidade;
      this.professionals.state = address.uf;
    }
  }
};
</script>

<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}

.input-group .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.badge {
  font-size: 0.75em;
}

.text-success {
  font-size: 0.85em;
}

.text-warning {
  font-size: 0.85em;
}

.integration-loading {
  position: absolute;
  top: 10px;
  right: 15px;
  z-index: 100;
}

.card {
  position: relative;
}


.feedback-messages {
  min-height: 20px;
}

.d-block {
  display: block !important;
}

.manchester-toggle {
  display: flex;
  align-items: center;
  height: 38px;
}

.switch {
  position: relative;
  display: inline-flex;
  margin: 0;
  cursor: pointer;
}

.switch input {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
}

.switch-track {
  position: relative;
  display: block;
  width: 40px;
  height: 22px;
  border-radius: 22px;
  background: #d0d0d0;
  transition: background-color 0.28s cubic-bezier(0.4, 0, 0.2, 1),
  box-shadow 0.2s ease;
}

.switch-thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.28);
  /* leve overshoot para o movimento nao parecer travado */
  transition: transform 0.32s cubic-bezier(0.34, 1.4, 0.64, 1);
}

.switch:hover .switch-track {
  box-shadow: 0 0 0 3px rgba(21, 72, 138, 0.1);
}

.switch input:focus-visible ~ .switch-track {
  box-shadow: 0 0 0 3px rgba(21, 72, 138, 0.25);
}

.switch input:checked ~ .switch-track {
  background: #15488a;
}

.switch input:checked ~ .switch-track .switch-thumb {
  transform: translateX(18px);
}

.switch-state {
  margin-left: 10px;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: #808285;
  transition: color 0.28s ease;
}

.switch-state-on {
  color: #15488a;
}

.manchester-reveal-enter-active {
  overflow: hidden;
  transition: opacity 0.3s ease 0.06s,
  transform 0.34s cubic-bezier(0.22, 1, 0.36, 1),
  max-height 0.34s cubic-bezier(0.22, 1, 0.36, 1);
}

.manchester-reveal-leave-active {
  overflow: hidden;
  transition: opacity 0.18s ease,
  transform 0.22s ease,
  max-height 0.22s ease;
}

.manchester-reveal-enter,
.manchester-reveal-leave-to {
  max-height: 0;
  opacity: 0;
  transform: translateY(-8px);
}

.manchester-reveal-enter-to,
.manchester-reveal-leave {
  max-height: 320px;
  opacity: 1;
  transform: translateY(0);
}

.manchester-result {
  background: #0f2445;
  color: #fff;
  border-radius: 6px;
  padding: 20px;
}

.manchester-result a {
  color: #8ab4f8;
}

.manchester-result dt {
  font-weight: 600;
}

.manchester-intro {
  margin-bottom: 16px;
}
</style>